var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39254 1.77349H3.47448L2.86358 5.82169C3.20721 5.78313 3.55083 5.74458 4.12355 5.74458C5.34534 5.74458 6.52896 6.01446 7.48349 6.59277C8.70528 7.28675 9.69798 8.63614 9.69798 10.641C9.69798 13.6867 7.29258 16 3.89447 16C2.17632 16 0.763621 15.4988 0 15.0361L0.534532 13.4169C1.18361 13.8024 2.44359 14.3036 3.85629 14.3036C5.8417 14.3036 7.52167 12.9928 7.52167 10.8723C7.52167 8.86747 6.14715 7.40241 3.05448 7.40241C2.13814 7.40241 1.45087 7.47952 0.878159 7.55663L1.87087 0H9.31617V1.77349H9.39254Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.8ad33efe5ba66333697e1e9190d4c1f9.svg";
export { ForwardRef as ReactComponent };